
define('ldsh!common/templates/download_leads_notification', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="task-status-info">\n  <i class="ri-loader-4-line fa-spin" aria-hidden="true"></i>\n  <i class="task__complete ri-check-line" style="display: none"></i>\n  <span class="txt js-message" data-i18n="leadsDownload.message.' +
((__t = ( getState() )) == null ? '' : __t) +
'"></span>\n  <div class="gap-16 ed-leads-buttons" style="display: none;">\n    <button\n      class="btn--rounded js-action p0"\n      data-i18n="[title]leadsDownload.button.' +
((__t = ( getState() )) == null ? '' : __t) +
'"\n    >\n      <i class="ri-download-2-line"></i>\n    </button>\n    <button\n      class="btn--rounded js-cancel p0"\n      data-i18n="[title]common.cancelButton"\n    >\n      <i class="ri-close-line"></i>\n    </button>\n  </div>\n</div>\n';

}
return __p
};});

